module.exports = __webpack_public_path__ + "img/wf.a21e1165.svg";